import { render } from "./ProtokolErfassen.vue?vue&type=template&id=bc838acc&scoped=true"
import script from "./ProtokolErfassen.vue?vue&type=script&lang=js"
export * from "./ProtokolErfassen.vue?vue&type=script&lang=js"

import "./ProtokolErfassen.vue?vue&type=style&index=0&id=bc838acc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc838acc"]])

export default __exports__